/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module MessageSounds
 * @description
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "messagesounds",
	init: init,
	listeners: listeners,

	_should_ring: false,
	_calling_state: null,
	handle_trigger_play: handle_sound_play,
	play_sound: play_sound
});

/**
 * Sets up listeners for triggers and initializes sound map
 */
function init() {
	this._calling_state = "idle";
}

function listeners() {
	return {
		"calling:statechange": handle_calling_update,
		"mqtt:$/message": handle_sound_play,
		"mqtt:$/notifications/new": handleNewGroupMessage
	};
}


function handleNewGroupMessage(data = {}) {
	const isGroupMessage = (data.type || []).some((type)=>type === "groupmessage");
	if (isGroupMessage){
		this.play_sound();
	}
}

function handle_sound_play() {
	if(this._calling_state !== "idle") {
		this._should_ring = true;
		return;
	}

	this.play_sound();
}

function play_sound() {
	this.emit("sounds:trigger:play", {
		sound: "message"
	});
	this._should_ring = false;
}


function handle_calling_update(data) {
	this._calling_state = data;
	if(this._should_ring && data === "idle"){
		this.play_sound();
	}
}
